"use strict";

var PlanCardHeader = require("./plan-card-header");
var PlanCardProFeatures = require("./plan-card-pro-features");
var PlanCardProButton = require("./plan-card-pro-button");
var PlanCardProUsersCapacity = require("./plan-card-pro-users-capacity");
var PlanCardPrice = require("./plan-card-price");

var config = require("app/util/config/config");
var TRIAL_DAYS = config.app.trialDays;

var PlanCardPro = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    accountUsers: React.PropTypes.number,
    currentPlan: React.PropTypes.object,
    expired: React.PropTypes.bool,
    selectedPlan: React.PropTypes.object,
    basePlan: React.PropTypes.object,
    subscriptionState: React.PropTypes.string,
    trial: React.PropTypes.string,
    userIsAdmin: React.PropTypes.bool,
  },
  componentWillMount: function() {
    var url = window.location.href;
    var isMktSite = this.props.isMktSite || url.includes("planos-precos");
    this.setState({
      isMktSite: isMktSite
    });
  },
  getDiscountExpiringTime: function(discount) {
    if (discount && typeof discount === "object" && discount.length > 1) {
      return this.props.basePlan.monthlyDiscounts[0].expiringTime;
    }
  },

  render: function() {
    var expiringTime = this.getDiscountExpiringTime(this.props.basePlan.monthlyDiscounts);

    return (
      <div className="planCard">
        <div className="planCard-headBackground">
          <PlanCardHeader
            planName={this.state.isMktSite? "Pro" : this.props.selectedPlan.name}
            defaultValue={this.props.basePlan.defaultValue}
            priceValue={this.props.basePlan.value}
            showAsterisk={false}/>
        </div>
        {
          this.state.isMktSite
          ? <PlanCardProMktSiteTitle />
          : <div>
              <PlanCardProUsersCapacity
                currentPlan={this.props.currentPlan}
                usersNumber={this.props.usersNumber}
                onUserPick={this.props.onUserPick} />
              <PlanCardPrice
                priceValue={this.props.selectedPlan.value}
                defaultValue={this.props.selectedPlan.defaultValue}
                discountExpiringTime={expiringTime}/>
            </div>
        }

        <PlanCardProFeatures />
        <PlanCardProButton {...this.props} />
      </div>
    );
  }
});

const PlanCardProMktSiteTitle = () => {
  return (
    <div className="planCardPro-mktSite-title">
      <div>Experiência completa</div>
      <div className="planCard-maxUsersNumber fs-30"> com sua equipe</div>
      <div> por {TRIAL_DAYS} dias grátis</div>
    </div>
  );
};

module.exports = PlanCardPro;



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/PlanSelector/plan-card-pro.jsx